import {FC} from 'react';
import {
  Headline,
  TitleR,
  SubtitleR,
  CaptionB,
  BodyNum,
  BodyM,
  BodyR,
  TinyNum,
  TinyM,
  TinyR,
} from './Text.styles';

export interface TextProps {
  text: string;
  type?:
    | 'headline'
    | 'titleR'
    | 'subtitleR'
    | 'captionB'
    | 'bodyNum'
    | 'bodyM'
    | 'bodyR'
    | 'tinyNum'
    | 'tinyM'
    | 'tinyR';
  color?: string;
  align?: 'left' | 'right' | 'center' | 'justify' | 'auto' | 'start' | 'end';
  display?: 'block' | 'inline';
}

const Text: FC<TextProps> = ({
  text,
  type = 'bodyR',
  color,
  align = 'left',
  display = 'block',
}) => {
  const renderText = (type: string) => {
    switch (type) {
      case 'headline':
        return (
          <Headline type={type} color={color} text={text} align={align} display={display}>
            {text}
          </Headline>
        );
      case 'titleR':
        return (
          <TitleR type={type} color={color} text={text} align={align} display={display}>
            {text}
          </TitleR>
        );
      case 'subtitleR':
        return (
          <SubtitleR
            type={type}
            color={color}
            text={text}
            align={align}
            display={display}>
            {text}
          </SubtitleR>
        );
      case 'captionB':
        return (
          <CaptionB type={type} color={color} text={text} align={align} display={display}>
            {text}
          </CaptionB>
        );
      case 'bodyNum':
        return (
          <BodyNum type={type} color={color} text={text} align={align} display={display}>
            {text}
          </BodyNum>
        );
      case 'bodyM':
        return (
          <BodyM type={type} color={color} text={text} align={align} display={display}>
            {text}
          </BodyM>
        );
      case 'bodyR':
        return (
          <BodyR type={type} color={color} text={text} align={align} display={display}>
            {text}
          </BodyR>
        );
      case 'tinyNum':
        return (
          <TinyNum type={type} color={color} text={text} align={align} display={display}>
            {text}
          </TinyNum>
        );
      case 'tinyM':
        return (
          <TinyM type={type} color={color} text={text} align={align} display={display}>
            {text}
          </TinyM>
        );
      case 'tinyR':
        return (
          <TinyR type={type} color={color} text={text} align={align} display={display}>
            {text}
          </TinyR>
        );
    }
  };
  return <>{renderText(type)}</>;
};

export default Text;
